import {createSlice} from '@reduxjs/toolkit';

import {
  builderCheckChortkeAvailability,
  builderGetAssortmentRegion,
  builderGetAssortmentVendor,
  builderGetProductsPriceTracking
} from './reducer';

const initialState: any = {
  loading: 0,
  gettingCheckChortkeAvailability: false,
  checkChortkeAvailabilitySuccess: false,
  checkChortkeAvailabilityData: {},
  gettingAssortmentRegion: false,
  assortmentRegionSuccess: false,
  assortmentRegionItems: [],
  gettingAssortmentVendor: false,
  assortmentVendorSuccess: false,
  assortmentVendorItems: [],
  productsPriceTracking: []
};

export const chortkeSlice = createSlice({
  name: 'chortke',
  initialState,
  reducers: {
    resetGetAssortmentItems: (state: any) => {
      state.gettingAssortmentRegion = false;
      state.assortmentRegionSuccess = false;
      state.assortmentRegionItems = [];
      state.gettingAssortmentVendor = false;
      state.assortmentVendorSuccess = false;
      state.assortmentVendorItems = [];
    }
  },
  extraReducers: (builder) => {
    //check chortke availability
    builderCheckChortkeAvailability(builder);

    //get assortment region
    builderGetAssortmentRegion(builder);

    //get assortment vendor
    builderGetAssortmentVendor(builder);

    //get product price tracking
    builderGetProductsPriceTracking(builder);
  }
});

export const {resetGetAssortmentItems} = chortkeSlice.actions;
export default chortkeSlice.reducer;
